import React, { ReactElement, useContext } from 'react'
import Modal from '@/components/common/Modal'
import { Currency } from '@/types/Page'
import { ConfigContext } from '@/components/common/ConfigContext'
import { ExtendedHotelInfo } from '@/lib/frontent-api'
import AppMap from '@/components/ui/search/AppMap'

interface FilterModalProps {
  closeModal: () => void
  whitelabel: boolean
  foundHotels: ExtendedHotelInfo[]
  searchActive: boolean
  visible: boolean
}

export default function MapModal(props: FilterModalProps): ReactElement {
  const config = useContext(ConfigContext)
  return (
    <Modal
      close={props.closeModal}
      mobileFullscreen={true}
      visible={true}
      hideHeader={true}
      background={true}
      noSroll={true}
      largeModal={true}
    >
      <AppMap
        whitelabel={props.whitelabel}
        currency={Currency.EUR}
        foundHotels={props.foundHotels}
        domain={config!.domain}
        searchActive={props.searchActive}
        config={config!}
        withNavigationControls={false}
        bookmarksPage={false}
      />
    </Modal>
  )
}
